import { Component, OnInit, HostListener, Inject, ViewChild } from '@angular/core';
import { FeatureFlow, Control } from '../../shared/models/Flow';
import { FeatureDTO } from '../../shared/models/features.model';
import { CategoryMapping } from '../../shared/models/category-mapping';
import { AdminService } from '../admin.service';
import { ImageRequest } from '../../shared/models/Flow';
import { DatePipe } from '@angular/common';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { TCCPConstantValues } from '../../shared/models/tccp-constants';
import { TCCPCommonService } from '../../shared/services/tccp-common.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatRadioChange } from '@angular/material/radio'
import { ConfirmModalComponent } from '../../shared/components/confirm-modal/confirm-modal.component';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import * as _ from 'lodash';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Vehicle } from '../../shared/models/vehicle';
import { BreadcrumbService } from 'src/modules/shared/components/breadcrumb/breadcrumb.service';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ManageVehicleService } from '../manage-vehicle/manage-vehicle.service';
import { year } from '../../shared/models/model-year';
import { Model } from '../../shared/models/model';
import { sample } from 'rxjs/operators';
import { PreviewImageComponent } from '../../shared/components/preview-image/preview-image.component';
import { MsalService } from '@azure/msal-angular';

@Component({
  selector: 'app-feature',
  templateUrl: './feature.component.html',
  styleUrls: ['./feature.component.scss']
})

export class FeatureComponent implements OnInit {
  public feature: FeatureDTO;
  public alerts = [];
  public showIcon = false ;
  public data: any;
  public imageSrc = '';
  public filename = '';
  public showError = false ;
  public imageName: string;
  public initialImageName: string;
  public features: any;
  public selectedFeature;
  public selectedFeatureIssueId: string;
  public isCopyClicked = false ;
  public featureCreationType: string[] = ['New', 'Copy From Existing'];
  public selectedFeatureCreationType = 'New';
  public featureInfo: FeatureFlow = < FeatureFlow > (
    {
      tagName: null, informationOrQuestion: null, issueId: null, controls: [],
      targetId: null, imagesOrVideos: [], type: null, notes: null, lastModifiedDate: null,
      featureType: null, category: 'None', hideProgressBar: false
    });

  public type: string;
  public isViewMode = false ;
  public isEditMode = false ;
  public isUpdateMode = false ;
  public isAddMode = true;
  public isEditModel = false ;
  public featureStatus = false ;
  public isModelSelected = false ;
  public pageTitle = '';
  public dateInfo = '';
  public featureName: string;
  public controlName: string;
  public displayName: string;
  public controls: Control[] = [];
  public showFeature: boolean;
  public thumbnilPath = '';
  public initialFeatureInfomation: any = {};
  public isFileNameValidated = false ;
  public featureList: any[];
  public isDisableCopy = true;
  public externalFeatureList: any[];
  public internalFeatureList: any[];
  public selectedModelName: Array< any >;
  public selectedModels = [];
  public selectedModelYear: Array< any >;
  public selectedModelYears: Array< any > = [];
  public yearList = [];
  public yearListOriginal = [];
  public vehicles: Vehicle = ({ model: null, classification: null, years: [], order: null }) as Vehicle;
  public year: year;
  public filteredModel;
  public models: Array< any >;
  public yearFilter = [];
  public documentsDataSource: MatTableDataSource< any > = new MatTableDataSource([]);
  public displayedColumns: string[] = [];
  public datasource: any;
  public selectedFeatureType: string;
  public selectedDivision: string;
  public targetFeatureName = '';
  public vehiclesModelFilter = [];
  public vehicleYearFilter = [];
  public fileContent: string | ArrayBuffer;
  public categoryList;
  public selectedS3ImageList = [];
  public imageOptionType = 'addImages';
  public isImageFromS3 = false ;
  public hideBreadcrumb = false;

  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;

  constructor(
    public commonService: TCCPCommonService, public adminService: AdminService, private datePipe: DatePipe,
    private vehicleService: ManageVehicleService,
    private breadcrumbService: BreadcrumbService,
    private router: Router, private dialog: MatDialog, private snackBar: MatSnackBar, private authService: MsalService) {
    this.adminService.navigateToFeature.subscribe(modeDetails => {
      if (modeDetails) {
        this.setPageMode(modeDetails);
      }
    });
    this.displayedColumns = ['name', 'classification', 'year'];
  }

  ngOnInit() {
    this.isModelSelected = false ;
    this.selectedFeatureCreationType = 'New';
    this.internalFeatureList = [];
    this.externalFeatureList = [];
    this.models = [];
    this.isViewMode = false ;
    this.isEditMode = false ;
    this.isAddMode = false ;
    let modeDetails = {};
    const selectedApp = this.adminService.selectedApplication;
    if (selectedApp === 'toyota') {
      this.categoryList = [{ name: 'Audio Multimedia', value: 'Audio Multimedia' },
      { name: 'Connected Services', value: 'Connected Services' }, { name: 'None', value: 'None' }];
    } else if (selectedApp === 'lexus') {
      this.categoryList = [{ name: 'Lexus Multimedia', value: 'Lexus Multimedia' },
      { name: 'Enform Services', value: 'Enform Services' }, { name: 'None', value: 'None' }];
    }
    this.getFeature();
    this.vehicleService.getAllVehicle().subscribe(data => {
      this.vehicleService.vehicle = data;
      this.vehicles = data;
    });

    if (this.vehicleService.vehicle) {
      this.vehicles = this.vehicleService.vehicle;
    }

    if (this.adminService.isFeatureInViewMode) {
      this.isViewMode = true;
      modeDetails = { mode: TCCPConstantValues.admin.FIXED_VALUES.VIEW, fromAdmin: true };
    } else {
      this.isAddMode = true;
      modeDetails = { mode: TCCPConstantValues.admin.FIXED_VALUES.ADD, fromAdmin: false };
    }
    this.setPageMode(modeDetails);
    this.thumbnilPath = TCCPConstantValues.admin.Urls.IMAGE_PATH;
  }

  public openDashBorad() {
    this.adminService.closeFeatureExpansionPanel.emit(true);
    this.router.navigateByUrl('/admin');
  }

  public showAlertMessages(messageType, message) {
    this.alerts = [];
    if (this.alerts.length === 0) {
      this.alerts.push({
        type: messageType,
        msg: message
      });
    }
  }

  closeAlerts() {
    this.alerts = [];
  }

  setPageMode(modeDetials?: any) {
    this.models = [];
    this.documentsDataSource.data = [];
    this.isModelSelected = false ;
    this.getAllFeature();
    if (modeDetials) {
      this.isViewMode = this.isAddMode = this.isEditMode = false ;
      if (modeDetials.mode === TCCPConstantValues.admin.FIXED_VALUES.ADD) {
        this.isAddMode = true;
        this.displayedColumns = ['name', 'year', 'classification', 'generation'];
        this.pageTitle = TCCPConstantValues.admin.FIXED_VALUES.ADD_FEATURE;
        this.alerts = [];
        this.controlName = null;
        const controls = < Control > ({ controlName: null, featureName: null, icon: null });
        this.controls = [];
        this.controls.push(controls);
        const selectedApp = this.adminService.selectedApplication;
        const feature = < FeatureFlow > (
          {
            tagName: null, informationOrQuestion: null, issueId: null, controls: this.controls,
            targetId: null, imagesOrVideos: [], type: null, notes: null, lastModifiedDate: null, featureType: null,
            category: 'None'
          });
        this.featureInfo = feature;
        console.log('this.featureInfo', this.featureInfo);
      } else if (modeDetials.mode === TCCPConstantValues.admin.FIXED_VALUES.VIEW) {
        this.isViewMode = true;
        this.selectedFeatureCreationType = 'New';
        this.pageTitle = TCCPConstantValues.admin.FIXED_VALUES.VIEW_FEATURE;
        this.displayedColumns = ['name', 'year', 'classification', 'generation'];
        if (modeDetials.fromAdmin) {
          const controls = < Control > ({ controlName: null, featureName: null, icon: null });
          this.controls = [];
          this.controls.push(controls);
          const feature = < FeatureFlow > (
            {
              tagName: null, informationOrQuestion: null, issueId: null, controls: this.controls,
              targetId: null, imagesOrVideos: [], type: null, notes: null, lastModifiedDate: null,
              featureType: null, category: ''
            });
          feature.category = feature.category === '' || feature.category === 'None' ? 'None' : feature.category;
          this.featureInfo = feature;

          console.log('this.featureInfo', this.featureInfo);
          this.getFeatureFlow(this.adminService.selectedFeatureTargetId);
          this.getVehicleByFeatureId(this.adminService.selectedFeatureTargetId);
          this.alerts = [];

        } else {
          this.adminService.expandedNode.push(modeDetials.currentNode);
          this.displayedColumns = ['name', 'year', 'classification', 'generation'];
          this.callrefreshFeatureTree(
            {
              node: this.adminService.expandedNode, issueId: this.featureInfo.controls[0]['issueId'],
              type: 'feature', featureType: modeDetials.featureType
            }
          );
        }
      } else if (modeDetials.mode === TCCPConstantValues.admin.FIXED_VALUES.EDIT) {
        this.selectedFeatureCreationType = 'New';
        this.pageTitle = TCCPConstantValues.admin.FIXED_VALUES.EDIT_FEATURE;
        this.isEditMode = true;
        this.displayedColumns = ['name', 'year', 'classification', 'generation'];
        this.isViewMode = this.isAddMode = false ;

      }
      this.initialFeatureInfomation = Object.assign({}, this.featureInfo);
    }
  }

  callrefreshFeatureTree(nodeDetails): void {
    this.adminService.callrefreshFeatureTree(nodeDetails);
  }

  updateGeneric(event) {
    if (event.checked === true) {
      this.featureInfo.isGeneric = true;
    }
  }

  enbleProgressBarDetail(event) {
    this.featureInfo.hideProgressBar = event.checked;
  }

  public getFeatureFlow(flowId: string) {
    this.adminService.getSubFeatureFlow(flowId).subscribe(response => {
      if (response) {
        this.featureInfo = response.Item;
        this.featureInfo.controls = response.Item.controls;

        this.featureInfo.category = this.featureInfo.category === undefined || this.featureInfo.category === '' ?
          'None' : this.featureInfo.category;
        this.initialFeatureInfomation = Object.assign({}, this.featureInfo);
        this.featureName = this.featureInfo.controls[0].featureName;
        this.controlName = this.featureInfo.controls[0].controlName;
        this.dateInfo = this.datePipe.transform(this.featureInfo.lastModifiedDate, TCCPConstantValues.admin.FIXED_VALUES.DATE_FORMAT);
        this.adminService.addStepClicked = false ;
        this.isImageFromS3 = response.Item.isImageFromS3 === undefined ? false  : response.Item.isImageFromS3;
        this.imageOptionType = this.isImageFromS3 ? 'selectImages' : 'addImages';
      }
    });
  }

  getAllFeature() {
    this.adminService.getFlow().subscribe(response => {
      if (response) {
        this.features = response;
      }
    });
  }

  featureSelectionChange(event) {
    this.selectedFeatureIssueId = event.value;
    this.isDisableCopy = this.featureInfo.featureType === undefined ? true : false ;
  }

  supportTopicTypeChange(event) {
    console.log('event.value' + event.value);
    this.isDisableCopy = true;
    this.selectedFeature = undefined;
    this.selectedFeatureIssueId = undefined;
    this.selectedFeatureType = event.value;
  }

  supportTopicTypeChangeByDivision(event) {
    console.log('event.value' + event.value);
    console.log('this.selectedFeatureType' + this.selectedFeatureType);
    this.isDisableCopy = true;
    this.selectedFeature = undefined;
    this.selectedFeatureIssueId = undefined;
    this.adminService.getFlow(this.selectedFeatureType, event.value).subscribe(response => {
      if (response) {
        this.features = response;
      }
    });
  }

  targetTypeChange(event: MatRadioChange) {
    this.featureInfo.featureType = event.value;
    this.isDisableCopy = this.selectedFeatureIssueId === undefined ? true : false ;
  }

  clearForm() {
    const controls = < Control > ({ controlName: null, featureName: null, icon: null });
    this.controls.push(controls);
    this.featureInfo = < FeatureFlow > (
      {
        tagName: null, informationOrQuestion: null, issueId: null, controls: this.controls,
        targetId: null, imagesOrVideos: [], type: null, notes: null, lastModifiedDate: null, featureType: null,
        category: 'None'
      });
  }

  findIconName(imagePath) {
    this.initialImageName = imagePath;
    this.imageName = imagePath;
    /* if (this.featureInfo.controls[0].icon.indexOf(this.thumbnilPath) > -1) {
      this.isImageFromS3 = true;
      this.imageOptionType = 'selectImages';
      this.imageName.replace(this.thumbnilPath, '');
    } */
    return this.imageName;
  }


  public getFeature() {
    this.adminService.getFlow().subscribe(response => {
      response.filter(obj => {
        if (obj.featureType === 'internal') {
          this.internalFeatureList.push({ controls: obj['controls'][0], issueId: obj.issueId });
        } else {
          this.externalFeatureList.push({ controls: obj['controls'][0], issueId: obj.issueId });
        }
      });
    });
  }

  public mandatoryCheck(mode?: string) {
    // add a optional param <mode? : string> to diff add/edit/copy
    let tagIndex = -1;
    if (mode && mode === 'copy') {
      const targetName = this.targetFeatureName.trim();
      if (this.featureInfo.featureType === 'internal') {
        this.internalFeatureList.forEach((item, i) => {
          if (item.controls.featureName === targetName) {
            return tagIndex = 1;
          }
        });
      } else {
        this.externalFeatureList.forEach((item, i) => {
          if (item.controls.featureName === targetName) {
            return tagIndex = 1;
          }
        });
      }
      if (tagIndex === -1) {
        this.targetFeatureName = targetName;
        return true;
      } else {
        this.showAlertMessages('error', TCCPConstantValues.admin.messages.PAGENAME_EXISTS_MESSAGE);
      }
    } else {
      const featureName: string = this.featureInfo.controls[0].featureName.trim();
      let isValid = false ;
      if (this.featureInfo.featureType === 'internal') {
        this.internalFeatureList.forEach((item, i) => {
          if (item.controls.featureName === featureName) {
            if (this.isAddMode) {
              return tagIndex = i;
            }
            if (this.featureInfo.issueId && item.issueId !== this.featureInfo.issueId) {
              return tagIndex = i;
            }
            return tagIndex;
          }
        });
      } else {
        this.externalFeatureList.forEach((item, i) => {
          if (item.controls.featureName === featureName) {
            if (this.isAddMode) {
              return tagIndex = i;
            }
            if (this.featureInfo.issueId && item.issueId !== this.featureInfo.issueId) {
              return tagIndex = i;
            }
            return tagIndex;
          }
        });
      }
      if (tagIndex === -1) {
        this.featureInfo.controls[0].featureName = featureName;
        isValid = true;
        if (this.featureInfo.controls[0].icon == null || this.featureInfo.controls[0].icon === '') {
          isValid = false ;
          this.showAlertMessages('error', TCCPConstantValues.admin.messages.ICON_MANDATORY_MESSAGE);
        } else {
          isValid = true;
        }
      } else {
        isValid = false ;
        this.showAlertMessages('error', TCCPConstantValues.admin.messages.PAGENAME_EXISTS_MESSAGE);
      }
      return isValid;
    }
  }

  deleteCategoryMappingOrder(issueId) {
    this.adminService.deleteCategoryMappingOrder(issueId).subscribe(response => {
      if (response) {

      }
    });
  }

  updateCategoryMappingOrder(categoryRequest) {
    const obj: CategoryMapping = < CategoryMapping > {};
    obj.category = categoryRequest.category;
    obj.updatedBy = this.authService.instance.getActiveAccount().username;
    obj.division = this.adminService.selectedApplication;
    obj.issueId = categoryRequest.issueId;
    obj.supportTopicName = categoryRequest.controls[0].featureName;
    obj.featureType = categoryRequest.featureType;
    this.adminService.getCategoryMappingOrder().subscribe(response => {
      if (response) {
        obj.order = response.length + 1;
        const requestArr = [];
        requestArr.push(obj);
        this.adminService.updateCategoryMappingOrder(requestArr).subscribe(updateresponse => {
          if (updateresponse) {
            console.log('updateCategoryMappingOrder', updateresponse);
          }
        });
      }
    });
  }

  openDeleteIconDialog(icon) {
    const dialogRef = this.dialog.open(ConfirmModalComponent, {
      width: '350px',
      id: 'admin-' + this.adminService.selectedApplication,
      data: 'Are you sure you want to delete the icon? '
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
           this.featureInfo.controls[0].icon = null;
      }
    });
  }

  public onSave(myForm: NgForm) {
    this.showError = true;
    this.adminService.addStepClicked = false ;
    if (this.mandatoryCheck()) {
      this.alerts = [];
      const requestData: FeatureFlow = < FeatureFlow > (this.featureInfo);
      this.isImageFromS3 = this.imageOptionType === 'selectImages' ? true : false ;
      requestData.isImageFromS3 = this.isImageFromS3;
      requestData.category = requestData.category === 'None' ? '' : requestData.category;
      requestData.type = 'Feature';
      requestData.status = 'draft';
      requestData.hideProgressBar = this.featureInfo.hideProgressBar === undefined ? false : this.featureInfo.hideProgressBar;
      const currentNode = { item: { featureName: requestData.controls[0].featureName } };
      const selectedFeatureType = this.featureInfo.featureType;
      if (requestData.imagesOrVideos === undefined) {
        requestData.imagesOrVideos = [];
      }
      if (requestData.isImageFromS3 === undefined) {
        requestData.isImageFromS3 = false ;
      }
      if (requestData.notes === undefined || requestData.notes === '') {
        requestData.notes = null;
      }
      if (requestData.controls === undefined) {
        requestData.controls = [];
      }
      if (requestData.lastModifiedDate === undefined) {
        requestData.lastModifiedDate = null;
      }
      if (requestData.informationOrQuestion === undefined) {
        requestData.informationOrQuestion = null;
      }
      if (requestData.featureType === undefined) {
        requestData.featureType = null;
      }
      if (requestData.category === undefined) {
        requestData.category = null;
      }
      requestData.lastModifiedBy = this.authService.instance.getActiveAccount().username;
      if (this.isEditMode) {
        const categoryRequest = Object.assign({}, this.featureInfo);
        this.adminService.updateSubFeatureFlow(requestData).subscribe((response: any) => {
          if (response) {
            if ((this.initialFeatureInfomation.category !== categoryRequest.category) && categoryRequest.category !== ''
              && this.initialFeatureInfomation.category !== 'None') {
              this.updateCategoryMappingOrder(categoryRequest);
            }

            if (this.initialFeatureInfomation.category !== '' && categoryRequest.category === '') {
              this.deleteCategoryMappingOrder(requestData.issueId);
            }
            this.showError = false ;
            this.showAlertMessages('success', 'The Support Topic is updated successfully');
            this.getFeatureFlow(this.featureInfo.issueId);
            this.getFeature();
            // Retrieve existing model mapping
            this.getVehicleByFeatureId(this.featureInfo.issueId);
            myForm.resetForm();
            this.isViewMode = true;
            this.isEditMode = false ;
            this.adminService.featureDataChanged = false ;
            this.callrefreshFeatureTree(
              {
                node: this.adminService.expandedNode,
                issueId: this.featureInfo.controls[0]['issueId'],
                type: 'feature',
                featureType: selectedFeatureType
              }
            );
          }
        });
      } else {
        requestData.createdBy = this.authService.instance.getActiveAccount().username;
        this.adminService.insertFeatureFlow(requestData).subscribe((response: any) => {
          if (response) {
            this.showError = false ;
            this.showAlertMessages('success', 'The Support Topic is added successfully');
            this.clearForm();
            myForm.form.markAsPristine();
            myForm.form.markAsUntouched();
            myForm.reset();
            this.getFeatureFlow(response.issueId);
            this.getFeature();
            this.isViewMode = true;
            this.isEditMode = false ;
            this.adminService.featureDataChanged = false ;
            this.setPageMode({
              mode: TCCPConstantValues.admin.FIXED_VALUES.VIEW,
              fromAdmin: false , currentNode, featureType: selectedFeatureType
            });
          }
        });
      }
    }
  }

  @HostListener('window:beforeunload')
  canDeactivate(): Observable< boolean > | boolean {
    this.alerts = [];
    const areSame: boolean = JSON.stringify(this.initialFeatureInfomation) === JSON.stringify(this.featureInfo);
    if ((this.isEditMode || this.isAddMode) && areSame === false ) {
      const dialogRef = this.dialog.open(ConfirmModalComponent, {
        width: '350px',
        data: TCCPConstantValues.admin.messages.LOST_UNSAVED_MESSAGE,
        position: { top: '100px' },
        id: 'admin-' + this.adminService.selectedApplication
      });
      return dialogRef.afterClosed();
    } else {
      return true;
    }
  }

  /**
   * Get Vehicle based on issueId
   * @description get all vehicles that has feature of this issue id
   * @param issueId - issue id of support topic
   */
  public getVehicleByFeatureId(issueId) {
    this.vehicleService.getAllVehiclesByFeature(issueId).subscribe((response: any) => {
      if (response) {
        this.models = [];
        const vehicles: Vehicle[] = response;
        this.filteredModel = vehicles;
        vehicles.forEach(vehicleModel => {
          const years = _.get(vehicleModel, 'years');
          years.forEach(modelYear => {
            const features: any[] = _.get(modelYear, 'features');
            this.yearListOriginal.push(_.get(modelYear, 'year'));
            const modelInstance: Model = {
              name: _.get(vehicleModel, 'model'),
              year: _.get(modelYear, 'year'),
              generation: _.get(modelYear, 'generation'),
              classification: _.get(vehicleModel, 'classification'),
              order: '' + vehicleModel.order
            };
            if (_.includes(features, issueId)) {
              this.models.push(modelInstance);
            }
          });
        });
        this.documentsDataSource.data = this.models;
        setTimeout(() => {
          this.documentsDataSource.sort = this.sort;
          this.documentsDataSource.paginator = this.paginator;
        });
        if (!_.isEmpty(this.models)) {
          this.isModelSelected = true;
        } else {
          this.isModelSelected = false ;
        }
      }
    });
  }

  ngAfterViewInit() {
    this.documentsDataSource.paginator = this.paginator;
    this.documentsDataSource.sort = this.sort;
  }

  openCancelDialog(featureForm: NgForm): void {
    this.adminService.featureDataChanged = false ;
    const dialogRef = this.dialog.open(ConfirmModalComponent, {
      width: '350px',
      data: TCCPConstantValues.admin.messages.LOST_UNSAVED_MESSAGE,
      id: 'admin-' + this.adminService.selectedApplication
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.isViewMode = true;
        this.isEditMode = false ;
        this.getFeatureFlow(this.adminService.selectedFeatureTargetId);
        this.alerts = [];
        if (this.isAddMode) {
          this.isViewMode = true;
          this.isAddMode = false ;
          featureForm.resetForm();
        }
      }
    });
  }

  public onFileChange(files: FileList, type: string) {
    this.thumbnilPath = TCCPConstantValues.admin.Urls.IMAGE_PATH;
    this.alerts = [];
    let isValid = false ;
    this.isFileNameValidated = false ;
    const iconExtensionTypes = ['image/svg+xml', 'image/png', 'image/jpg', 'image/jpeg'];
    if (files[0].type.indexOf('image') !== -1) {
      if (iconExtensionTypes.indexOf(files[0].type) === -1) {
        this.showAlertMessages('error', TCCPConstantValues.admin.messages.SVG_PNG_FORMAT_MESSAGE);
        isValid = false ;
      } else {
        isValid = true;
      }
    } else if (type === 'unknown') {
      this.showAlertMessages('error', TCCPConstantValues.admin.messages.SVG_PNG_FORMAT_MESSAGE);
      isValid = false ;
    } else {
      this.showAlertMessages('error', TCCPConstantValues.admin.messages.SVG_PNG_FORMAT_MESSAGE);
      isValid = false ;
    }

    if (files[0].name !== '') {
      const ext = files[0].name.split('.').pop();
      this.filename = files[0].name.replace('.' + ext, new Date().getTime() + '.' + ext);
      if (isValid) {
        const fileRequestBody = new ImageRequest();
        fileRequestBody.source = this.adminService.selectedApplication;
        fileRequestBody.contentType = files[0].type;
        fileRequestBody.fileName = this.filename;
        fileRequestBody.contentBase64 = null;
        const reader = new FileReader();
        reader.readAsDataURL(files[0]);
        reader.onload = () => {
          this.adminService.uploadImage(fileRequestBody).subscribe((response: any) => {
            if (response) {
              this.uploadtoS3(files[0], response.url, files[0].type, response.path);
            }
          });
        };
      }
    }
  }

  uploadtoS3(fileRequest: File, response: string, type: string, path) {
    this.adminService.uploadtoS3(fileRequest, response, type).subscribe(() => {
      this.featureInfo.controls[0].icon = path;
    });
  }

  public removeFeature() {
    const selectedFeatureType = this.featureInfo ? this.featureInfo.featureType : '';
    const dialogRef = this.dialog.open(ConfirmModalComponent, {
      width: '350px',
      id: 'admin-' + this.adminService.selectedApplication,
      data: TCCPConstantValues.admin.messages.SUPPORT_TOPIC_DELETE_CONFIRMATION_MESSAGE
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.adminService.deleteFeatureFlow(this.featureInfo.issueId).subscribe((response: any) => {
          this.adminService.expandedNode = [];
          this.adminService.isSelectedNodeExpanded = {};
          this.showError = false ;
          this.showAlertMessages('success', TCCPConstantValues.admin.messages.SUPPORT_TOPIC_DELETE_MESSAGE);
          this.clearForm();
          this.callrefreshFeatureTree(
            {
              node: this.adminService.expandedNode,
              issueId: this.featureInfo.controls[0]['issueId'],
              type: 'feature',
              action: 'delete',
              featureType: selectedFeatureType
            }
          );
        });
      }
    });
  }

  public editFeature(featureForm, issueId) {
    this.alerts = [];
    this.isEditMode = true;
    this.getVehicleByFeatureId(issueId);
    this.getFeatureFlow(issueId);
    this.pageTitle = TCCPConstantValues.admin.FIXED_VALUES.EDIT_FEATURE;
    this.setPageMode({ mode: TCCPConstantValues.admin.FIXED_VALUES.EDIT, fromAdmin: false });
    this.adminService.nodeBeforeFeatureChange = this.adminService.selectedNode;
    this.isViewMode = this.isAddMode = false ;
    if (featureForm.submitted !== true) {
      this.adminService.featureDataChanged = true;
    } else {
      this.adminService.featureDataChanged = false ;
    }
  }

  public addStepFromFeature() {
    this.adminService.featureDetails = this.featureInfo;
    this.adminService.addStepClicked = true;
    this.adminService.fromFeaturePage = true;
    const flowRoute = this.router.url === '/admin/flow';
    if (flowRoute) {
      this.adminService.navigateToFlow.emit({ mode: TCCPConstantValues.admin.FIXED_VALUES.ADD, fromAdmin: false });
    } else {
      this.router.navigate(['admin/flow']);
    }
  }

  changeOrder(control, direction) {
    let haveSwapped = false ;
    if (this.featureInfo && this.featureInfo.controls && this.featureInfo.controls.length > 0) {
      this.featureInfo.controls.forEach((obj, index) => {
        if (control.controlName.trim().toLowerCase() === obj.controlName.trim().toLowerCase()) {
          const swappingItem = this.featureInfo.controls[index];
          if (direction === 'up') {
            if (!haveSwapped) {
              if (index < 1) {
                const swappingIndex = index < 1 ? this.featureInfo.controls.length - 1 : index;
                this.featureInfo.controls[index] = this.featureInfo.controls[swappingIndex];
                this.featureInfo.controls[swappingIndex] = swappingItem;
                haveSwapped = true;
              } else {
                this.featureInfo.controls[index] = this.featureInfo.controls[index - 1];
                this.featureInfo.controls[index - 1] = swappingItem;
                haveSwapped = true;
              }
            }
          } else {
            if (!haveSwapped) {
              if (index === this.featureInfo.controls.length - 1) {
                const swappingIndex = index === this.featureInfo.controls.length - 1 ? 0 : index;
                this.featureInfo.controls[index] = this.featureInfo.controls[swappingIndex];
                this.featureInfo.controls[swappingIndex] = swappingItem;
                haveSwapped = true;
              } else {
                this.featureInfo.controls[index] = this.featureInfo.controls[index + 1];
                this.featureInfo.controls[index + 1] = swappingItem;
                haveSwapped = true;
              }
            }
          }
        }
      });
    }
  }

  /* Copy Feature Functionality starts Here */
  featureCreationTypeChange(event) {
    this.selectedFeatureCreationType = event.value;
  }

  onCopyFeature(event) {
    this.isCopyClicked = true;
    this.isDisableCopy = this.isDisableCopy || this.targetFeatureName === '';
    if (this.mandatoryCheck('copy') && !this.isDisableCopy) {
      const initialInfo = Object.assign({}, this.initialFeatureInfomation);
      const featureDetails = Object.assign({}, this.featureInfo);
      if (JSON.stringify(featureDetails) !== JSON.stringify(initialInfo) || this.isEditMode) {
        const dialogRef = this.dialog.open(ConfirmModalComponent, {
          width: '400px',
          data: 'Copy will override all the entered data. Continue?',
          position: { top: '100px' },
          id: 'admin-' + this.adminService.selectedApplication
        });
        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            this.copyFeature(this.selectedFeatureIssueId);
          }
        });
      } else {
        this.copyFeature(this.selectedFeatureIssueId);
      }
    }
  }

  public copyFeature(flowId: string) {
    let crossDivisionCopy = false;
    if(this.selectedDivision !== this.adminService.selectedApplication){
      crossDivisionCopy = true;
    }
    this.adminService.copyFeature(flowId, this.featureInfo.featureType,
      this.authService.instance.getActiveAccount().username, this.targetFeatureName, this.selectedDivision, crossDivisionCopy).subscribe(response => {
        if (response) {
          this.getFeature();
          this.snackBar.open('Support Topic Copied Successfully.', '', {
            duration: 2000,
            panelClass: ['green-snackbar']
          });
          this.callrefreshFeatureTree(
            {
              node: this.adminService.expandedNode,
              issueId: '',
              type: 'feature',
              action: 'copy',
              featureType: '',
              user: ''
            }
          );
        }
      });
  }

  /* Copy Feature Functionality ends Here */

  /* Preview Functionality starts Here */
  previewFeature() {
    environment.applicationName = this.adminService.selectedApplication;
    const dialogRef = this.dialog.open(PreviewFeatureDialogComponent, {
      width: '500px',
      height: '380px',
      position: { top: '10%' }
    });
    this.breadcrumbService.showBreadcrumb.emit(true);
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  /* Preview Functionality ends Here */

  /* Select image from S3 */

  openS3ImageDeleteConfirmDialog(index) {
    this.selectedS3ImageList.splice(index, 1);
  }

  onImageOptionChange(event) {
    // this.featureInfo.controls[0].icon = null;
  }

  openS3ImageDialog() {
    const dialogRef = this.dialog.open(PreviewImageComponent, {
      height: '98%',
      width: '100vw',
      maxWidth: '95vw',
      panelClass: 'full-screen-modal',
      data: { type: 'Feature' }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result && result.event && result.event === 'save') {
        this.initialImageName = result.data[0];
        const imageName = result.data[0];
        this.featureInfo.controls[0].icon = imageName.replace(this.thumbnilPath, '');
        this.isImageFromS3 = true;
        this.imageOptionType = 'selectImages';
      }
    });
  }
}

@Component({
  selector: 'app-preview-feature-dialog-component',
  templateUrl: './preview-feature-dialog.html',
  styleUrls: ['./feature.component.scss']

})
export class PreviewFeatureDialogComponent implements OnInit {
  public alerts: any[] = [];
  public imageSrc = '';
  public filename = '';
  public icon = '';
  public type: string;
  public thumbnilPath = '';
  public fileDisplayname = '';
  public appName: string = environment.applicationName;
  public initialIcon: string = null;
  public initialImageMode: string = null;
  public hideBreadcrumb = false;

  constructor(
    public dialogRef: MatDialogRef<FeatureComponent>,
    private adminService: AdminService, @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  public featureInfo = [];

  ngOnInit() {
    this.getFeatureFlow(this.adminService.selectedFeatureTargetId);
    this.thumbnilPath = TCCPConstantValues.admin.Urls.IMAGE_PATH;
  }

  public getFeatureFlow(flowId: string) {
    this.adminService.getSubFeatureFlow(flowId).subscribe(response => {
      if (response) {
        this.initialIcon = response.Item.controls[0].icon;
        this.initialImageMode = response.Item.controls[0].icon.indexOf(this.thumbnilPath) > -1 ? 'selectImages' : 'addImages';
        this.featureInfo = response.Item.controls;
        this.adminService.addStepClicked = false ;
      }
    });
  }

  close(): void {
    environment.applicationName = 'admin';
    this.dialogRef.close();
  }

}
